import { align } from './align';
import { check } from './check';
import { extract } from './extract';
import { getNMaxY } from './getNMaxY';
import { growingX } from './growingX';
import { integral } from './integral';
import { integration } from './integration';
import { maxClosestYPoint } from './maxClosestYPoint';
import { maxY } from './maxY';
import { maxYPoint } from './maxYPoint';
import { maximaY } from './maximaY';
import { minClosestYPoint } from './minClosestYPoint';
import { minYPoint } from './minYPoint';
import { minimaY } from './minimaY';
import { peakInfo } from './peakInfo';
import { realMaxYPoint } from './realMaxYPoint';
import { realMinYPoint } from './realMinYPoint';
import { reduce } from './reduce';
import { toXYObject } from './toXYObject';

export const XY = {
  align,
  check,
  extract,
  getNMaxY,
  integral,
  integration,
  maxY,
  maximaY,
  maxYPoint,
  minimaY,
  minYPoint,
  reduce,
  growingX,
  minClosestYPoint,
  maxClosestYPoint,
  realMaxYPoint,
  realMinYPoint,
  peakInfo,
  toXYObject,
};
